<template>
	<div id='' class='gPageBorder' v-loading='loading'>
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<div id=''>
				<div style=''>
					<el-row>
						<el-col :span="8" class=''>
							<el-button class='gSgLeftBtn' type='primary'
								@click='jumpToAdd'>{{$t('app_addApp')}}</el-button>

						</el-col>
						<el-col :span="4">
							<div class='gCtrl'>
							</div>
						</el-col>

						<el-col :span="4">
							<div class='gCtrl'>
							</div>
						</el-col>

						<el-col :span="4">
							<div class='gCtrl'>
							</div>
						</el-col>


						<el-col :span="4">
							<div class='gSideCtrl'>
								<el-input :placeholder="$t('app_appName')" v-model='appName'
									@keyup.enter.native='query' icon="search" :on-icon-click="query"></el-input>
							</div>
						</el-col>

					</el-row>


				</div>
			</div>

			<div id=''>
				<el-table @row-click='cellClick' :data="tableData" border ref="multipleTable" class='tbPoint gTopMg'
					style="width: 100%;border:none;">
					<!-- <el-table-column header-align='center' align='center' prop="appId" :label="$t('psp_app_id')"
						width="">
					</el-table-column> -->
					<el-table-column header-align='center' align='center' prop="appName" :label="$t('app_appName')"
						width="">
					</el-table-column>
					<el-table-column header-align='center' align='center' prop="appVersion"
						:label="$t('psp_app_version')" width="">
					</el-table-column>


					<el-table-column header-align='center' align='center' prop="createTime" width='175'
						:label="$t('app_ulTime')">
					</el-table-column>
					<el-table-column header-align='center' align='center' prop="operate" width='106'
						:label="$t('app_operate')">
						<template slot-scope='scope'>
							<el-tooltip class="item" effect="dark" :content="$t('app_del')" placement="top">
								<el-button type='text' @click='deleteApps(scope.row)'><i class="fa fa-trash"
										style="color:#FF4949"></i></el-button>
							</el-tooltip>
					
						</template>
					</el-table-column>

				</el-table>

				<div class="gPgDiv" style=''>
					<el-pagination class='gPg' @current-change="pageSelect" @size-change="pageSized"
						:current-page="index" :page-sizes='$gRows' :page-size="row"
						layout="total, sizes, prev, pager, next, jumper" :total="total">
					</el-pagination>
				</div>
			</div>

		</el-tabs>



		<tyc :tqobj='tqobj'></tyc>
	</div>
</template>

<style>
	// html,body{width:100%;height:100%;}

	.tbPoint td {
		cursor: pointer;
	}

	.cmMarginFrame {
		width: calc(100% - 20px);
		height: 100%;
		background: none;
		margin-left: 10px;
	}

	#appDepot {
		min-width: 840px;
	}

	#adData {}
</style>

<script>
	import mm from "moment";
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import tyc from '@/components/global/tyc'
	import tagc from '@/components/global/tagc'
	//import autoTerno from '../global/TernoAutoCtrl'
	export default {
		components: {
			MechanismSelector,
			tyc,
			tagc
		},
		data() {
			var that = this
			return {
				cmtStatusArr: [],
				activeName: this.$t('psp_app_manage'),
				mechanismData: {
					value: null,
					placeholder: that.$t('lin_global.place_areaid'),
					callback(value) {
						that.mech = value
						that.getCmDv()
					}
				},

				isNon: false,
				mech: "",
				deviceList: [],
				deviceTotal: 0,
				select_device: [],
				tqobj: '',
				device_loading: false,
				mechanismDatas: {
					value: null,
					placeholder: that.$t('lin_global.place_areaid'),
					callback(value) {
						that.uninsatll_form.mechId = value
						that.getUnstallList()
					}
				},

				sstatus: {
					'0': this.$t('app_new'),
					'1': this.$t('app_enable')
				},
				uninstallData: [],
				uninstallTotal: 0,
				uninsatll_form: {
					page: 1,
					rows: 10,
					terminalNo: "",
					mechId: ""
				},
				orderName: '',
				orderType: '',
				appvst: '',
				pkg: '',
				cerDialogVisible: false,
				cerTipDialogVisible: false,
				dvLoading: 0,
				appId: "",
				stModel: [{
						label: this.$t("app_online"),
						vl: "1"
					},
					{
						label: this.$t("app_offline"),
						vl: "2"
					},
					{
						label: this.$t("app_new"),
						vl: "0"
					}
				],
				channels: [],
				sNum: 0,
				cleanMode: false,
				multipleSelection: [],
				tempSelect: [],
				srchValue: "",
				channelId: "",
				cerTipMsg: "",
				status: "",
				index:1,
				dvIndex: 1,
				dialogVisible: 0,
				mechanismId: window.localStorage["mechanismId"],
				mechId: '',
				tableData: [],
				dvTableData: [],
				appTypes: [],
				appTypeValue: "",
				// selectAll: {},
				appvStatus: [{
						label: this.$t("app_prePushVerify"),
						value: "0"
					},
					{
						label: this.$t("app_preVerify"),
						value: "1"
					},
					{
						label: this.$t("app_verifyPass"),
						value: "2"
					},
					{
						label: this.$t("app_verifyNotPass"),
						value: "3"
					}
				],
				sstatusAr: [{
						vl: '',
						lb: this.$t('app_all')
					},
					{
						vl: '0',
						lb: this.$t('app_new')
					},
					{
						vl: '1',
						lb: this.$t('app_enable')
					}
				],
				// appStatus: [
				//   { label: this.$t("app_prePushVerify"), value: "0" },
				//   { label: this.$t("app_preVerify"), value: "1" },
				//   { label: this.$t("app_verifyPass"), value: "2" },
				//   { label: this.$t("app_verifyNotPass"), value: "3" }
				// ],
				appStatusValue: "",
				total: 0,
				dvTotal: 0,
				loading: 0,
				appType: "",
				queryKey: "",
				appName: "",
				show_push: false,
				select_form: {
					page: 1,
					rows: 20,
					areaid: "",
					snBegin: "",
					snEnd: "",
					terminal_status: "",
					terminal_no: ""
				},
			};
		},
		methods: {
			handleSelectionChangeDevice(val) {
				this.select_device = val
			},
			open_push() {
				this.show_push = true;
				this.getCmDv()
				// this.get_device_list()
			},
			handleClose() {
				this.show_push = false;
				this.select_form = {
					page: 1,
					rows: 20,
					areaid: "",
					snBegin: "",
					snEnd: "",
					terminal_status: "",
					terminal_no: ""
				}
				var that = this;
				that.mech = ""
				this.mechanismData = {
					value: null,
					placeholder: that.$t('lin_global.place_areaid'),
					callback(value) {
						that.mech = value
						that.getCmDv()
					}
				}

			},
			// 批量推送
			bcPush() {
				var terminalNo_list = []
				var mechId_list = []
				var mechName_list = []
				this.select_device.forEach(obj => {
					terminalNo_list.push(obj.terminalNo)
					mechId_list.push(obj.mechanismId)
					mechName_list.push(obj.mechName)
				})

				var tip = this.$t('app_surepsxdv').replace('{num}', this.select_device.length)

				this.$showConfirm(this.$t('app_tip'), tip + ' ?', this.$t('app_sure'), this.$t('app_cancel'), 'warning',
					() => {
						let sub_form = {
							terminalNo: String(terminalNo_list),
							mechId: String(mechId_list),
							mechName: String(mechName_list)
						}
						this.device_loading = true
						this.$pspUnPush(sub_form, (
							res) => {
							this.device_loading = false
							if (res.status === 200) {
								this.$message.success(res.message)
								this.show_push = false;
								this.getUnstallList()
							} else {
								this.$message.error(res.message)
							}
						}, () => {
							// error
							this.device_loading = false
						})
					}, '')
			},
			// 推送全部
			pushAll() {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_ispushalldv') + ' ?', this.$t('app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
					this.select_form.areaid = this.mech
					console.log(this.select_form)
					console.log("推送全部")
					// this.loading = true
					// this.$appendPush(this.pObj.taskId, '', '1', this.mech, this.queryKey, '', terminalstats,this.snBegin,this.snEnd, (
					// 	res) => {
					// 	this.loading = false
					// 	if (res.status === 200) {
					// 		//console.log(res.data)
					// 		this.$message.success(res.message)
					// 		this.pushdev = false
					// 	} else {
					// 		this.$message.error(res.message)
					// 	}
					// }, () => {
					// 	// error
					// 	this.loading = false
					// })
				}, '')
			},
			// 单个推送
			pushed(row) {
				this.$showConfirm(this.$t('app_tip'), this.$t('app_srpush') + ' ' + row.terminalNo + ' ?', this.$t(
					'app_sure'), this.$t(
					'app_cancel'), 'warning', () => {
					console.log(row)
					let sub_form = {
						terminalNo: row.terminalNo,
						mechId: row.mechanismId,
						mechName: row.mechName,
					}
					this.device_loading = true
					this.$pspUnPush(sub_form, (
						res) => {
						this.device_loading = false
						if (res.status === 200) {
							this.$message.success(res.message)
							this.show_push = false;
							this.getUnstallList()
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.device_loading = false
					})
				}, '')
			},
			pageSizedDevice(vl) {
				this.select_form.rows = vl
				this.getCmDv()
			},
			pageSelectDevice(vl) {
				this.select_form.page = vl
				this.getCmDv()
			},
			getCmDv() {
				var _this = this
				var typeKey = 'terminalTypes'
				this.tqobj = {
					keys: [typeKey],
					callback: (data) => {
						_this.cmtStatusArr = data[0]
					}
				}
				this.get_device_list()
			},
			mkDvSt(row) {
				return this.sstatus[row.terminalStatus]
			},
			get_device_list() {
				this.device_loading = true
				this.$getNonItDv(this.select_form.page, this.select_form.rows, this.mech, this.select_form.terminal_no,
					this.select_form.terminal_status, "", '', '', this.select_form.snBegin, this.select_form.snEnd, (
						res) => {
						this.device_loading = 0
						if (res.status === 200) {
							//console.log(res.data)
							this.deviceList = res.data
							this.deviceTotal = res.total
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.device_loading = 0
					})
			},

			handleClick(tab, event) {
				// console.log(tab, event);
				this.getAppList()
				this.getUnstallList()
			},
			// 批量删除
			batchDeleteRow() {
				//let self = this
				this.$confirm(this.$t('terminal.list.delete_tips'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					let ids = []
					for (let i = 0; i < this.multipleSelection.length; i++) {
						ids.push(this.multipleSelection[i].id)
					}
					this.$delUnPsp(
						String(ids),
						res => {
							if (res.status === 200) {
								this.$message.success(res.message);
								this.getUnstallList();
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				}).catch(() => {

				})
			},
			delete_all() {
				//let self = this
				this.$confirm(this.$t('del_allData'), this.$t('lin_btn.tips'), {
					confirmButtonText: this.$t('lin_btn.confirm'),
					cancelButtonText: this.$t('lin_btn.cancel'),
					type: 'warning'
				}).then(() => {
					console.log(this.uninsatll_form)
					let sub_form = {
						terminalNo: this.uninsatll_form.terminalNo,
						mechId: this.uninsatll_form.mechId
					}
					this.$delUnPspAll(
						sub_form,
						res => {
							if (res.status === 200) {
								this.$message.success(res.message);
								this.uninsatll_form = {
									page: 1,
									rows: 20,
									terminalNo: "",
									mechId: ""
								}
								var that = this;
								this.mechanismDatas = {
									value: null,
									placeholder: that.$t('lin_global.place_areaid'),
									callback(value) {
										that.uninsatll_form.mechId = value
										that.getUnstallList()
									}
								}
								this.getUnstallList();
							} else {
								this.$message.error(res.message);
							}
						},
						""
					);
				}).catch(() => {

				})
			},
			jumpToAdd() {
				this.$setWObj("editUpdatePSPConfig", {
					type: 0 // 新增
				});
				this.$router.push({
					path: 'updatePsp/add'
				});
			},
			editApp(row) {
				this.$setWObj("editUpdatePSPConfig", {
					data: row,
					type: 1 // 编辑
				});
				this.$router.push({
					path: 'updatePsp/edit'
				});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val

			},
			query() {
				this.getAppList();
			},
			reset() {
				this.appName = "";
				this.getAppList();
			},
			pageSelect(index) {
				this.index = index;
				this.getAppList();
			},
			pageSized(val) {
				this.$gRow = val;
				this.getAppList();
			},

			pageSelectUn(index) {
				this.uninsatll_form.page = index;
				this.getUnstallList();
			},
			pageSizedUn(val) {
				this.uninsatll_form.rows = val;
				this.getUnstallList();
			},


			deleteApp(obj) {
				this.$showConfirm(
					this.$t("app_tip"),
					this.$t("app_tipMkDel"),
					this.$t("app_sure"),
					this.$t("app_cancel"),
					"warning",
					() => {
						this.$delPsp(
							obj.id,
							res => {
								if (res.status === 200) {
									this.$message.success(res.message);
									this.getAppList();
								} else {
									this.$message.error(res.message);
								}
							},
							""
						);
					},
					""
				);
			},
			deleteApps(obj) {
				this.$showConfirm(
					this.$t("app_tip"),
					this.$t("app_tipMkDel"),
					this.$t("app_sure"),
					this.$t("app_cancel"),
					"warning",
					() => {
						this.$delChangePsp(
							obj.id,
							res => {
								if (res.status === 200) {
									this.$message.success(res.message);
									this.getAppList();
								} else {
									this.$message.error(res.message);
								}
							},
							""
						);
					},
					""
				);
			},
			// 点击行
			cellClick(row, ev, col) {
				var label = col.label
				if (!label) return
				if (label === this.$t("app_operate")) {
					return;
				} else {
					this.$setWObj("updatePspDetail", {
						data: row,
						type:2
					});
					this.$router.push({
						path: 'updatePsp/detail'
					});
				}

			},
			getAppList() {
				this.loading = 1;
				this.$changePspList({
						page: this.index,
						rows: this.$gRow,
						fileType:2,
						appName: this.appName
					},
					res => {
						console.log(res);
						this.loading = 0;
						if (res.status === 200) {
							this.total = res.total;
							this.tableData = res.data;
						} else {
							this.$message(res.message);
						}
					},
					() => {
						this.loading = 0;
						this.$message.error(this.$t("app_rqsError"));
					}
				);

			},
			getUnstallList() {
				console.log(this.uninsatll_form)
				// this.loading = 1;
				this.$pspUnList(this.uninsatll_form,
					res => {
						console.log(res);
						this.loading = 0;
						if (res.status === 200) {
							this.uninstallTotal = res.total;
							this.uninstallData = res.data;
						} else {
							this.$message(res.message);
						}
					},
					() => {
						// this.loading = 0;
						this.$message.error(this.$t("app_rqsError"));
					}
				);

			},
			dateFormat(row, column) {
				var date = row[column.property];
				if (date === undefined) {
					return "";
				}
				return mm(date).format("YYYY-MM-DD HH:mm:ss");
			},
		},
		mounted() {
			this.getAppList()
			// this.getUnstallList()
		},
		destroyed() {}
	};
</script>


// WEBPACK FOOTER //
// updatePsp.vue?7e504b6c